module.exports = __webpack_public_path__ + "img/Ciberseguridad-211024.a310725f.jpg";